<template lang="pug">
.footer-markup
  .footer-markup__block.footer-markup__block_logo
    .footer-markup__logo(v-if='logo')
      .footer-markup__logo-image(:style='`background-image: url(${logo})`')
    .footer-markup__copyright Copyright {{ currentYear }}
    .footer-markup__name {{ name }}

    .footer-markup__inlearno
      div Реализовано на технологиях
      //- TODO FIXIT вынести адрес а конфигурацию
      a.footer-markup__inlearno-link(
        href='https://inlearno.ru/?utm_source=navigator',
        target='_blank'
      )
  .footer-markup__block.footer-markup__block_alias(v-if='$slots.alias')
    slot(name='alias')

  .footer-markup__block.footer-markup__block_menu(v-if='!$slots.alias')
    slot(name='menu')

  .footer-markup__block.footer-markup__block_firm(v-if='!$slots.alias')
    slot(name='info')

  .footer-markup__block.footer-markup__block_info
    .footer-markup__phone
      slot(name='phones')
    .footer-markup__email
      slot(name='emails')
    div
      slot(name='counter')
    div
      slot(name='socialNetworks')
</template>

<script>
export default {
  props: {
    logo: {
      type: String,
    },

    name: {
      type: String,
    },
  },

  data: () => ({ currentYear: new Date().getFullYear() }),
};
</script>

<style lang="stylus" scoped>
@import '../../../stylus/helpers/mediaqueriesStep'

.footer-markup
  &__block
    width 100%
    display inline-block
    vertical-align top
    margin-bottom 20px
    padding-left 10px
    padding-right 10px
    text-align center

    &:first-child
      padding-left 0

    &:last-child
      padding-right 0

    &.wide
      width 100%

    +tablet-desktop()
      width 25%
      margin-bottom 0

    &_alias
      +tablet-desktop()
        width 55%

    &_logo
      text-align center

    &_menu
      +tablet-desktop()
        text-align left
        width 30%

    &_firm
      color #485b84

      +tablet-desktop()
        text-align left

    &_info
      a
        line-height 24px

      +tablet-desktop()
        text-align right
        width 20%

  &__email
    font-size 14px

  &__logo
    margin-bottom 8px
    position relative

  &__logo-image
    background-repeat no-repeat
    background-position center center
    background-size contain
    opacity .3
    height 50px

  &__inlearno
    &-link
      background url(./images/inlearno-min.png) center center no-repeat
      height 40px
      display inline-block
      width 100px
      opacity .3
      transition opacity 0.2s ease

      &:hover
        opacity 1

  &__copyright
  &__name
    max-width 250px
    padding-bottom 1em

  &__inlearno
  &__copyright
  &__name
    margin 0 auto
    text-align center
    color #c9c9db
    font-size 13px
    font-family 'Open Sans', sans-serif

    +tablet-desktop()
        margin 0

  &__inlearno
  &__copyright
  &__name
  &__logo
    +tablet-desktop()
      padding-right 50px

.ticket
  font-size 14px
  line-height 2.3
  font-weight 600
  color #3b3b40
  text-transform uppercase
  text-decoration none
  opacity .3
  transition opacity 0.2s ease

  &:hover
    opacity 1
</style>



// WEBPACK FOOTER //
// Markup.vue?ff494a24